import { useReveal } from "../hooks/useReveal";
import "./Network.css";

export default function Network({ data }) {
  const r1 = useReveal(), r2 = useReveal(), r3 = useReveal(), r4 = useReveal();

  const buildersDouble = [...(data?.builders||[]), ...(data?.builders||[])];
  const fundsDouble    = [...(data?.funds||[]),    ...(data?.funds||[])];

  return (
    <div className="nw">

      {/* HERO */}
      <section className="nw-hero">
        <div className="nw-hero-inner wrap">
          <div>
            <span className="nw-hero-tag">{data?.hero?.tag}</span>
            <h1 className="nw-hero-h1">
              {data?.hero?.h1?.map((line,i)=>(
                <span key={i} className={line===data?.hero?.italic?"italic":""}>{line}<br/></span>
              ))}
            </h1>
          </div>
          <div>
            <p className="nw-hero-p">{data?.hero?.body}</p>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="nw-stats" ref={r1}>
        <div className="nw-stats-g wrap">
          {data?.stats?.map((s,i)=>(
            <div className="nw-stat rv" key={i}>
              <div className="nw-stat-v">{s.value}</div>
              <div className="nw-stat-l">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* THREE TIERS */}
      <section className="nw-tiers" ref={r2}>
        <div className="nw-tiers-grid wrap">
          {data?.tiers?.map((t,i)=>(
            <div className="nw-tier-card rv" key={i}>
              <span className="nw-tier-tag">{t.tag}</span>
              <h2 className="nw-tier-h2">{t.h2}</h2>
              <p className="nw-tier-p">{t.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* BUILDERS MARQUEE */}
      <section className="nw-builders" ref={r3}>
        <div className="nw-mq-hd wrap">
          <span className="nw-mq-tag rv">Tier 1 & Growth-Stage</span>
          <h2 className="nw-mq-h2 rv">Builders & Developers</h2>
        </div>
        <div className="mq-wrap">
          <div className="mq-track mq-fwd">
            {buildersDouble.map((b,i)=>(
              <div className="mq-item" key={i}>
                <img src={b.logo} alt={b.name} loading="lazy"/>
                <span className="mq-name">{b.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FUNDS MARQUEE */}
      <section className="nw-funds" ref={r4}>
        <div className="nw-mq-hd wrap">
          <span className="nw-mq-tag rv">Institutional Capital</span>
          <h2 className="nw-mq-h2 rv">Global Funds & NBFCs</h2>
        </div>
        <div className="mq-wrap mq-wrap-light">
          <div className="mq-track mq-bwd">
            {fundsDouble.map((f,i)=>(
              <div className="mq-item mq-item-light" key={i}>
                <img src={f.logo} alt={f.name} loading="lazy"/>
                <span className="mq-name">{f.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
